export default __webpack_public_path__ + "static/media/people_type_three.b459a6db.svg";